import { sendComagic, sendGoogle, sendYandex } from "../Analytics";
import ApplicationState from "../ApplicationState";
import Submitter from "../form/Submitter";
import Validator from "../form/Validator";

export default function initPage404()
{
    ordinary404();
    emptySearchResult();
}

function emptySearchResult()
{
    let goals = ApplicationState.commonStorage.get('emptySearchMetrics');

    if (!goals) {
        return;
    }

    if ('ya' in goals && 'goal' in goals.ya) {
        sendYandex(goals.ya.goal);
    }

    if ('ga' in goals && 'category' in goals.ga && 'action' in goals.ga) {
        sendGoogle(goals.ga.category, goals.ga.action);
        sendComagic(goals.ga.category, goals.ga.action);
    }
}

function ordinary404()
{
    let questionForm = document.getElementById('form-404') as HTMLFormElement;

    if (questionForm !== null) {
        let validationConfig = {name: 'cyrillic', phone: 'phone'};

        new Submitter(questionForm, '/request/commit/', new Validator(validationConfig)).init();
    }

    if (!!ApplicationState.commonStorage.get('is_page_404')) {
        sendGoogle('Ошибка', 'Ошибка 404');
    }
}
